<template></template>
<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export default {
  name: "FormsListener",
  props: {
    collection: String,
    userID: String
  },
  data() {
    return {
      unsubscribe: null
    };
  },
  mounted() {
    var self = this;

    this.unsubscribe = firebase
      .firestore()
      .collection(self.collection)
      .doc(self.userID)
      .collection("forms")
      .onSnapshot(function(querySnapshot) {
        var formsArray = [];
        querySnapshot.forEach(function(doc) {
          var tempDoc = doc.data();
          tempDoc.id = doc.id;
          formsArray.push(tempDoc);
        });
        self.$emit("forms-real-time", formsArray);
      });
  },
  destroyed() {
    this.unsubscribe();
    // destroy connections
  }
};
</script>
